@if (mapItem(); as mapItem) {
    <ui-detail-view-container>
        <ui-detail-section>
            <ui-detail-image
                [imagePath]="mapItem.imagePath"
                [altText]="mapItem.title"
            />
            <ui-detail-title [title]="mapItem.title"/>
            <ui-detail-address [text]="mapItem.address"/>
            <ui-detail-tags
                [tags]="mapItem.specialUsageKinds"
            />
        </ui-detail-section>

        @if (mapItem.shortDescription) {
            <ui-detail-description
                [htmlDescription]="mapItem.shortDescription"
            />
        }

        @if (hasSettings()) {
            <ui-detail-section
                title="Eigenschaften"
            >
                @if (mapItem.ambience; as value) {
                    <ui-detail-description
                        title="Ambiente"
                        [htmlDescription]="value"
                    />
                }

                @if (mapItem.area; as value) {
                    <ui-detail-description
                        title="Platzgröße"
                        [htmlDescription]="value"
                    />
                }

                @if (mapItem.poleCount; as value) {
                    <ui-detail-description
                        title="Anzahl der Masten"
                        [htmlDescription]="value.toString()"
                    />
                }

                @if (mapItem.usableArea; as value) {
                    <ui-detail-description
                        title="Nutzbare Fläche"
                        [htmlDescription]="value"
                    />
                }

                @if (mapItem.restrictions; as value) {
                    <ui-detail-description
                        title="Einschränkungen"
                        [htmlDescription]="value"
                    />
                }
            </ui-detail-section>
        }

        @if (hasEnvironment()) {
            <ui-detail-section title="Umgebung">
                @if (mapItem.electricitySupply; as value) {
                    <ui-detail-description
                        title="Strom-Infrastruktur"
                        [htmlDescription]="value"
                    />
                }

                @if (mapItem.waterSupply; as value) {
                    <ui-detail-description
                        title="Wasser-Infrastruktur"
                        [htmlDescription]="value"
                    />
                }

                @if (mapItem.nextPublicTransportStop; as value) {
                    <ui-detail-description
                        title="Nächste Haltestelle"
                        [htmlDescription]="value"
                    />
                }

                @if (mapItem.nextCarPark; as value) {
                    <ui-detail-description
                        title="Nächstes Parkhaus"
                        [htmlDescription]="value"
                    />
                }
            </ui-detail-section>
        }

        @if (mapItem.links; as value) {
            <ui-detail-description
                title="Links"
                [htmlDescription]="value"
            />
        }
    </ui-detail-view-container>
}
